import { useEffect, useState } from 'preact/hooks';

import { checkDivs } from '@/rules';
import Box from './Box';
import Indicator from './Indicator';

export default function DivPlacement({ rule }) {
	const [valid, setValid] = useState(checkDivs(rule.then));
	useEffect(() => {
		if (valid) {
			return;
		}
		const interval = setInterval(() => {
			if (valid) {
				clearInterval(interval);
			}
			if (checkDivs(rule.then)) {
				setValid(true);
			}
		}, 1000);

		return () => clearInterval(interval);
	}, [rule, valid]);

	const { disableMakeDiv, useQuerySelectorAll, args } = rule.then[0] ?? {};
	const [formKey, domain, divName] = args;

	const idAsName = /[a-zA-Z]/.test(divName?.charAt(0));

	return (
		<Box name="div-placement">
			<Box name="condition-rule-container">
				<Indicator small active={valid || !disableMakeDiv} mr={1} />
				<Box>
					<Box name="condition-rule">
						Rendering form into {idAsName ? '#' : ''}
						{divName}
					</Box>
					<Box name="invalid-reason">
						{disableMakeDiv ? 'Placement handled manually' : 'Placement handled by deployment'}
					</Box>
					{useQuerySelectorAll && <Box name="invalid-reason">Renders into all elements with matching selector</Box>}
				</Box>
			</Box>
		</Box>
	);
}
